import { BasicConfig, CHARTS_CONFIG } from './basic-config'
export const echartsType = 'Line'
export class Line extends BasicConfig {
  constructor(options) {
    super(options)
    this.init(options)
  }
  init(options) {
    const { code } = options
    this.initLegend()
    this.initSeries()
    // this.initTitle()
    this.initTooltip()
    this.option = this.initOption()
    this.code = code
  }
  initOption() {
    const { series, color, legend, tooltip } = this
    return {
      series,
      color,
      legend,
      tooltip,
    }
  }
  initSeries() {
    this.series = [
      {
        name: 'namename',
        type: 'pie',
        radius: ['50%', '60%'], // 半径配置
        avoidLabelOverlap: true,
        label: {
          show: false,
          position: 'center'
        },
        center: ['50%', '35%'],
        selectedMode: 'single',
        data: this.data
      }
    ]
  }
  initLegend() {
    const { legend = {} } = this
    this.legend = {
      ...CHARTS_CONFIG.legend,
      ...legend,
    }
  }
  initTooltip() {
    const { tooltip } = this
    this.tooltip = {
      ...CHARTS_CONFIG.tooltip,
      ...tooltip,
    }
  }
}
Line.echartsType = echartsType



// WEBPACK FOOTER //
// ./src/public/components/kye-report-form/echarts/common/basic/line.js